import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { routes } from "../../helper/routes";
import { history } from "../../helper/history";
import _ from "lodash";
import { questionMCQAnswerTypeConstants, questionTypeConstants } from "../../helper/constants";
import FileUpload from "../../components/common/form/FileUpload";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import AdminTemplate from '../../components/admin/layouts/Template';
import Spinner from "../../components/common/Spinner";
import Card from "../../components/common/Card";
import CardHeader from "../../components/common/CardHeader";
import CardBody from "../../components/common/CardBody";
import CardTitle from "../../components/common/AssessmentCardTitle";
import Breadcrumb from "../../components/common/Breadcrumb";
import BreadcrumbItem from "../../components/common/BreadcrumbItem";
import CheckBox from "../../components/common/form/CheckBox";
import CheckBoxInline from "../../components/common/form/CheckBoxInline";
import RadioInline from '../../components/common/form/RadioInline.js';
import Radio from '../../components/common/form/Radio.js';
import Button from "../../components/common/form/Button";
import { convertFromRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import CustomEditor from "../../components/common/editor/ViewEditor.js";
import { questionActions } from "../../actions/assessment/questionActions";
import { userActions } from "../../actions/user_management/userActions";
import AssessmentInfoCard from "./components/AssessmentInfoCard.js";

class StudentView extends React.Component {
  constructor(props) {
    super(props);

    this.ref_tagify = React.createRef();
    this.state = {
      assessment_title: "",
      assessmentQuestionsData: [],
      questions_contents_by_type: {},
      backToFinalize: false,
      questions: [],
      subQuestions: [],
      subQuestionsIndexes: []
    };
  }

  async componentDidMount() {
    if (window.KTSelect2) window.KTSelect2.init();
    if (window.KTBootstrapDatepicker) window.KTBootstrapDatepicker.init();
    if (window.KTIONRangeSlider) window.KTIONRangeSlider.init();
    if (window.KTApp.initComponents) window.KTApp.initComponents();
    if (window.$) window.$(".selectpicker").selectpicker();
    if (typeof window.KTLayoutStickyCard !== "undefined") {
      window.KTLayoutStickyCard.update();
    } else {
      if (window.KTLayoutStickyCard)
        window.KTLayoutStickyCard.init("kt_page_sticky_card");
    }

    await this.props.getUsers();
    var user_id = sessionStorage.getItem("userID");
    if (_.isEqual({}, this.props.userMap)) {
      this.props.createUserMap();
    }

    let questions = this.props.assessmentFilteredQuestions?.filter(item => item.is_subquestion !== "true");
    this.setState({
      questions: questions
    })

    // Store all subquestions keyed by their question_id
    let subQuestionsObject = {};
    this.props.assessmentFilteredQuestions.forEach((item) => {
      if (item.is_subquestion === "true") {
        subQuestionsObject[item.question_id] = item.content;
      }
    });
    this.setState({
      subQuestions: subQuestionsObject
    })

    let subQuestionsIndexes = this.props.assessmentFilteredQuestions.map((item, index) => item.is_subquestion === "true" ? index : null)
      ?.filter(index => index !== null);
    this.setState({
      subQuestionsIndexes: subQuestionsIndexes
    })


    await this.props.assessment;
    this.setState({ assessment_title: this.props.assessment.title });

    window.onpopstate = function (event) {
      history.push(routes.view_assessment);
      window.location.reload();
    };
  }

  async componentDidUpdate() {
    if (
      this.props.assessmentFilteredQuestions &&
      this.props.assessmentFilteredQuestions.length &&
      !this.state.assessmentQuestionsData.length
    ) {
      var question_list = this.state.questions,
        i;

      for (i = 0; i < question_list.length; i++) {
        question_list[i]["question_number"] = i + 1; //adding "question_number" as prperty for each questions
      }
      this.setState({ assessmentQuestionsData: question_list });
    }
  }

  changeRoute() {
    window.location = routes.view_assessment;
  }

  onClickBackbtn = () => {
    this.setState({
      backToFinalize: true,
    })
  }

  getQuestionPassageContent = (content) => {
    let states = JSON.parse(content);
    let passageContentState = EditorState.createWithContent(convertFromRaw(states[0]));
    return passageContentState;
  }

  renderQuestionWithPassage(question, content, index) {
    return (
      <>
        {question.is_passage && question.passage_id && question.passage_content &&
          <>
            <div className="mb-5 mt-5">
              <CustomEditor editorState={this.getQuestionPassageContent(question.passage_content)} />
            </div>
            <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
          </>
        }
        <h3 className="row align-items-center mb-5 overflow-hidden all-questions-title">
          <div className="col-md-1 col-1 number-wrap">{index + 1}.</div>
          <div className="col-md-11 col-11 rdw-editor-question">
            <CustomEditor editorState={content} />
          </div>
        </h3>
      </>
    );
  }

  renderQuestionWithPassageForPartSection(question, content, index, localIndex) {
    return (
      <>
        {question.is_passage && question.passage_id && question.passage_content &&
          <>
            <div className="mb-5 mt-5">
              <CustomEditor editorState={this.getQuestionPassageContent(question.passage_content)} />
            </div>
            <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
          </>
        }
        <h3 className="row align-items-center mb-5 overflow-hidden all-questions-title">
          <div className="col-md-1 col-1 number-wrap">{localIndex + 1}.</div>
          <div className="col-md-11 col-11 rdw-editor-question">
            <CustomEditor editorState={content} />
          </div>
        </h3>
      </>
    );
  }

  renderQuestionForPartSection = (questionData, i, localIndex) => {
    let indexes = this.state.subQuestionsIndexes
    let subQuestions = {};
      indexes.forEach(index => {
        if (this.props.questionContents.hasOwnProperty(index)) {
          subQuestions[index] = this.props.questionContents[index];
        }
      });
    let filteredQuestionContents = this.props?.questionContents?.filter((item, index) => !indexes.includes(index));
    const states = JSON.parse(filteredQuestionContents[i]);
    const tempQuestionState = EditorState.createWithContent(convertFromRaw(states[0]));
    // DESCRIPTIVE
    if (questionData.question_type === questionTypeConstants.DESCRIPTIVE.name) {
      return (
        <div className="col-md-12" key={`descriptive-${i}`}>
          {this.renderQuestionWithPassageForPartSection(questionData, tempQuestionState, i, localIndex)}
          <div className="RichEditor-root-descriptive-answer" id="editAnswer">
            <Editor
              placeholder="Add your answer here..."
              editorStyle={{ maxHeight: "200px", overflow: "auto" }}
              toolbarClassName="vertical-toolbar"
              readOnly={true}
            />
          </div>
        </div>
      );
    }

    // MCQ
    else if (questionData.question_type === questionTypeConstants.MCQ.name) {
      states.shift(); // remove the question part
      const tempAnswerStates = states.map(state =>
        EditorState.createWithContent(convertFromRaw(state))
      );

      return (
        <div className="col-md-12" key={`mcq-${i}`}>
          {this.renderQuestionWithPassageForPartSection(questionData, tempQuestionState, i, localIndex)}
          <div className={`RichEditor-root parent-class ${tempAnswerStates.some(a => a.getCurrentContent().getPlainText().length > 100) ? "single-column" : ""}`}>
            {tempAnswerStates.map((answer, j) => (
              <div className="row d-flex align-items-center child-class" key={j}>
                <div className="col-md-2 col-2">
                  {questionData.answer_type_id === questionMCQAnswerTypeConstants.One.id ?
                    <RadioInline><Radio key={j} onClick={""} checked={""} style={{ color: "#5458AF" }} /></RadioInline> :
                    <CheckBoxInline><CheckBox key={j} onClick={""} checked={""} style={{ color: "#5458AF" }} /></CheckBoxInline>
                  }
                </div>
                <div className="col-md-10 col-10 px-0">
                  <CustomEditor editorState={answer} />
                </div>
              </div>
            ))}
          </div>

        </div>
      );
    }

    // SUBMISSION
    else if (questionData.question_type === questionTypeConstants.SUBMISSION.name) {
      let reload = false;
      return (
        <div className="col-md-12" key={`submission-${i}`}>
          {this.renderQuestionWithPassageForPartSection(questionData, tempQuestionState, i, localIndex)}
          <div className="col-md-10" />
          <FileUpload
            className="col-md-10 col-form-label"
            key={i}
            id={""}
            title={""}
            defaultFile={""}
            callBack={""}
            reload={reload}
            questionIndex={""}
          />
        </div>
      );
    }

    // SUBQUESTION
    else if (questionData.question_type === questionTypeConstants.SUBQUESTION.name) {
      const subQuestionIds = questionData.sub_questions
        ? questionData.sub_questions.split(',').map(id => id.trim())
        : [];

      const contentParsed = questionData.content ? JSON.parse(questionData.content) : null;
      const tempQuestionState = contentParsed
        ? EditorState.createWithContent(convertFromRaw(contentParsed[0]))
        : EditorState.createEmpty();

      return (
        <div className="col-md-12" key={`main-subquestion-${i}`}>
          {this.renderQuestionWithPassageForPartSection(questionData, tempQuestionState, i, localIndex)}

          {subQuestionIds.map((subIdStr, j) => {
            const subId = parseInt(subIdStr);
            const subContentRaw = this.state.subQuestions[subId];
            if (!subContentRaw) return null;

            const subContentParsed = JSON.parse(subContentRaw);
            const editorState = EditorState.createWithContent(convertFromRaw(subContentParsed[0]));

            return (
              <div className="col-md-12" key={`sub-${subId}`}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-1 col-1 number-wrap" style={{ fontWeight: "600" }}>
                    {j + 1}.
                  </div>
                  <div className="col-md-11 col-11 rdw-editor-question" style={{ fontWeight: "500" }}>
                    <CustomEditor editorState={editorState} />
                  </div>
                </div>

                <div className="RichEditor-root-descriptive-answer" id={`editAnswer-${subId}`}>
                  <Editor
                    placeholder="Add your answer here..."
                    editorStyle={{ maxHeight: "200px", overflow: "auto" }}
                    toolbarClassName="vertical-toolbar"
                    readOnly={true}
                  />
                </div>

              </div>
            );
          })}
        </div>
      );
    }

  return null;
}

  renderQuestion = (questionData, i) => {
    let indexes = this.state.subQuestionsIndexes
    let subQuestions = {};
      indexes.forEach(index => {
        if (this.props.questionContents.hasOwnProperty(index)) {
          subQuestions[index] = this.props.questionContents[index];
        }
      });
    let filteredQuestionContents = this.props?.questionContents?.filter((item, index) => !indexes.includes(index));
    const states = JSON.parse(filteredQuestionContents[i]);
    const tempQuestionState = EditorState.createWithContent(convertFromRaw(states[0]));
    // DESCRIPTIVE
    if (questionData.question_type === questionTypeConstants.DESCRIPTIVE.name) {
      return (
        <div className="col-md-12" key={`descriptive-${i}`}>
          {this.renderQuestionWithPassage(questionData, tempQuestionState, i)}
          <div className="RichEditor-root-descriptive-answer" id="editAnswer">
            <Editor
              placeholder="Add your answer here..."
              editorStyle={{ maxHeight: "200px", overflow: "auto" }}
              toolbarClassName="vertical-toolbar"
              readOnly={true}
            />
          </div>
        </div>
      );
    }

    // MCQ
    else if (questionData.question_type === questionTypeConstants.MCQ.name) {
      states.shift(); // remove the question part
      const tempAnswerStates = states.map(state =>
        EditorState.createWithContent(convertFromRaw(state))
      );

      return (
        <div className="col-md-12" key={`mcq-${i}`}>
          {this.renderQuestionWithPassage(questionData, tempQuestionState, i)}
          <div className={`RichEditor-root parent-class ${tempAnswerStates.some(a => a.getCurrentContent().getPlainText().length > 100) ? "single-column" : ""}`}>
            {tempAnswerStates.map((answer, j) => (
              <div className="row d-flex align-items-center child-class" key={j}>
                <div className="col-md-2 col-2">
                  {questionData.answer_type_id === questionMCQAnswerTypeConstants.One.id ?
                    <RadioInline><Radio key={j} onClick={""} checked={""} style={{ color: "#5458AF" }} /></RadioInline> :
                    <CheckBoxInline><CheckBox key={j} onClick={""} checked={""} style={{ color: "#5458AF" }} /></CheckBoxInline>
                  }
                </div>
                <div className="col-md-10 col-10 px-0">
                  <CustomEditor editorState={answer} />
                </div>
              </div>
            ))}
          </div>

        </div>
      );
    }

    // SUBMISSION
    else if (questionData.question_type === questionTypeConstants.SUBMISSION.name) {
      let reload = false;
      return (
        <div className="col-md-12" key={`submission-${i}`}>
          {this.renderQuestionWithPassage(questionData, tempQuestionState, i)}
          <div className="col-md-10" />
          <FileUpload
            className="col-md-10 col-form-label"
            key={i}
            id={""}
            title={""}
            defaultFile={""}
            callBack={""}
            reload={reload}
            questionIndex={""}
          />
        </div>
      );
    }

    // SUBQUESTION
    else if (questionData.question_type === questionTypeConstants.SUBQUESTION.name) {
      const subQuestionIds = questionData.sub_questions
        ? questionData.sub_questions.split(',').map(id => id.trim())
        : [];

      const contentParsed = questionData.content ? JSON.parse(questionData.content) : null;
      const tempQuestionState = contentParsed
        ? EditorState.createWithContent(convertFromRaw(contentParsed[0]))
        : EditorState.createEmpty();

      return (
        <div className="col-md-12" key={`main-subquestion-${i}`}>
          {this.renderQuestionWithPassage(questionData, tempQuestionState, i)}

          {subQuestionIds.map((subIdStr, j) => {
            const subId = parseInt(subIdStr);
            const subContentRaw = this.state.subQuestions[subId];
            if (!subContentRaw) return null;

            const subContentParsed = JSON.parse(subContentRaw);
            const editorState = EditorState.createWithContent(convertFromRaw(subContentParsed[0]));

            return (
              <div className="col-md-12" key={`sub-${subId}`}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-1 col-1 number-wrap" style={{ fontWeight: "600" }}>
                    {j + 1}.
                  </div>
                  <div className="col-md-11 col-11 rdw-editor-question" style={{ fontWeight: "500" }}>
                    <CustomEditor editorState={editorState} />
                  </div>
                </div>

                <div className="RichEditor-root-descriptive-answer" id={`editAnswer-${subId}`}>
                  <Editor
                    placeholder="Add your answer here..."
                    editorStyle={{ maxHeight: "200px", overflow: "auto" }}
                    toolbarClassName="vertical-toolbar"
                    readOnly={true}
                  />
                </div>

              </div>
            );
          })}
        </div>
      );
    }

  return null;
}

render() {
    let question_content;

    if (this.state.backToFinalize) {
      return <Redirect to={routes.setup_assessment} />;
    }

    if (this.state.assessmentQuestionsData.length && this.props?.sections.length !== 0) {
      const { assessmentQuestionsData } = this.state;

      const groupedQuestions = {};

      assessmentQuestionsData.forEach((qData, i) => {
        const { part_id, section_id, part_name, section_name, section_title } = qData;
        const { allow_part_instruction, part_instruction, allow_section_instruction, section_instruction } = qData;
        const sectionMeta = this.props?.sections.find(
          s => s.section_id === qData.section_id
        );
        if (!groupedQuestions[part_id]) {
          groupedQuestions[part_id] = {
            name: part_name,
            allow_part_instruction: allow_part_instruction,
            part_instruction: part_instruction,
            part_display_order: sectionMeta?.part_display_order,
            sections: {},
          };
        }

        if (!groupedQuestions[part_id].sections[section_id]) {
          groupedQuestions[part_id].sections[section_id] = {
            name: section_name,
            title: section_title,
            allow_section_instruction: allow_section_instruction,
            section_instruction: section_instruction,
            section_display_order: sectionMeta?.section_display_order,
            questions: [],
          };
        }

        groupedQuestions[part_id].sections[section_id].questions.push({
          data: qData,
          index: i,
        });
      });

      // Render grouped questions with proper formatting
      question_content = (
        <>
        <AssessmentInfoCard details={this.props.assessment_details} />

        {Object.entries(groupedQuestions).sort(([, a], [, b]) => a.part_display_order - b.part_display_order).map(([partId, part]) => (
        <div key={`part-${partId}`} className="mb-5 p-4 border rounded bg-light">
          <h2 className="text-primary mb-4">{part.name}</h2>

        {/* Show Part Instruction if allowed */}
        {part.allow_part_instruction && part.part_instruction && (
          <div className="mb-3">
            <ul className="mb-3" style={{ paddingLeft: '1.5rem' }}>
              {part.part_instruction.split('\n').map((line, idx) => (
                <li key={`part-inst-${idx}`}>{line.replace(/^•\s*/, '').trim()}</li>
              ))}
            </ul>
          </div>
        )}

          {Object.entries(part.sections).sort(([, a], [, b]) => a.section_display_order - b.section_display_order).map(([sectionId, section]) => (
            <div key={`section-${sectionId}`}>
              <h4 className="text-secondary mb-3" style={{ color: '#bd7b00' }}>{section.title}</h4>

            {/* Show Section Instruction if allowed */}
            {section.allow_section_instruction && section.section_instruction && (
              <div className="mb-3">
                <ul className="mb-3" style={{ paddingLeft: '1.5rem' }}>
                  {section.section_instruction.split('\n').map((line, idx) => (
                    <li key={`section-inst-${idx}`}>{line.replace(/^•\s*/, '').trim()}</li>
                  ))}
                </ul>
              </div>
            )}

              <div className="mb-5 p-4 border rounded bg-white">
                <hr />
                <div className="question-list">
                  {section.questions.map(({ data, index }, localIndex) => (
                    <div key={`question-${index}`} className="mb-4 pb-3 border-bottom">
                      {this.renderQuestionForPartSection(data, index, localIndex)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
      </>)
    }
    else {
      question_content = this.state.assessmentQuestionsData.map((data, index) => (
        <div key={`question-${index}`} className="mb-4 pb-3 border-bottom">
          {this.renderQuestion(data, index)}
        </div>
      ));
    }

    return (
      <AdminTemplate>
        <ContentWrapper>
          {this.props.loading && (
            <Spinner id="show" text="Loading, Please wait!" />
          )}
          {/* begin::Card */}
          {this.state.assessment_title != undefined ? (
            <div style={{ height: "90vh", overflow: "auto" }}>
              <Card>
                <CardHeader>
                  <CardTitle cardLabel={this.props.assessment.title}>
                    <Breadcrumb>
                      <BreadcrumbItem
                        to={routes.view_assessment}
                        breadcrumbItemName="Go Back to Assessments Library"
                      />
                      {/* <BreadcrumbItem
                      to={routes.setup_assessment}
                      active="active"
                      breadcrumbItemName="Finalize"
                    /> */}
                    </Breadcrumb>
                  </CardTitle>
                  {/* <Button
                    className="btn btn-primary mr-2"
                    btnName="Back"
                    onClick={this.onClickBackbtn}
                    type="button"
                  /> */}
                </CardHeader>
                <CardBody>
                  <div className="container-fluid pt-4">
                    <div className="row justify-content-center">
                      <div className="col-12 px-0">
                        {question_content}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          ) : (
            <div>
              {" "}
              <Redirect to={routes.view_assessment} />
            </div>
          )}

        </ContentWrapper>

      </AdminTemplate>
    );
  }
}

function mapStateToProps(state) {
  return {
    userMap: state.userReducer.userMap,
    assessment: state.questionReducer.assessment,
    question: state.questionReducer.question,
    questionContents: state.questionReducer.questionContents,
    questions: state.questionReducer.questions,
    sections: state.questionReducer.sections,
    assessment_details: state.questionReducer.assessment_details,
    assessmentQuestions: state.questionReducer.assessmentQuestions,
    assessmentFilteredQuestions: state.questionReducer.assessmentFilteredQuestions,
    loading: state.questionReducer.loading,
  };
}

const mapActionsToProps = {
  createUserMap: userActions.createUserMap,
  refreshPage: questionActions.refreshPage,
  getUsers: userActions.getAllUsers,
  getAssessmentQuestions: questionActions.getAssessmentQuestions,
  getAllAssessmentQuestions: questionActions.getAllAssessmentQuestions,
  getAllQuestions: questionActions.getAllQuestions,
  getQuestionContent: questionActions.getQuestionContent,
  getAllQuestionContentsByType: questionActions.getAllQuestionContentsByType,
  getAllQuestionContents: questionActions.getAllQuestionContents,
  getQuestionTypes: questionActions.getQuestionTypes,
};

export default connect(mapStateToProps, mapActionsToProps)(StudentView);
